export default "skymp5-front/8749009b5bfec7d16246d5e56bca8999.png";